// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2mN8H","container":"styles_container__1JIzS","title":"styles_title__2dLAa","wrapper":"styles_wrapper__7AfEB","answer":"styles_answer__2qN35"};